import { Breadcrumb, Button, Card, Form, Input, Modal, Select } from "antd";
import { ReactComponent as TitleIcon } from "../../../../assests/images/settingsBreadCum.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useCallback, useEffect, useState } from "react";
import CommonOtp from "../../../../components/otp";
import AccountCard from "../../../../components/account-card";
import AccountSelectedCard from "../../../../components/account-selected-card";
import AccountDisplay from "../../../../components/account-display";
import AccountDisplayView from "../../../../components/account-display-view";
import ChequeService from "../../../../services/cheque.service";
import { CONFIG } from "../../../../environment";
import { useSelector } from "react-redux";
import { ReactComponent as HomeIcon } from "../../../../assests/images/home-line.svg";
import {
  accountListSelector,
  profileDetailsSelector,
  selectedAccountSelector,
} from "../../../../store/selectors/app.selector";
import SettingsService from "../../../../services/settings.service";
import {
  allowOnlyAlphaNumericsWithSpaceAndComma,
  allowOnlyNumbers,
} from "../../../../services/common.service";
import { IoCheckmarkCircleSharp, IoRadioButtonOff } from "react-icons/io5";
import { ReactComponent as TickIcon } from "../../../../assests/images/tickIcon.svg";

const defaultType = {
  home: false,
  custom: false,
  branch: false,
};
export default function ChequeBookRequest() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [otp, setOtp] = useState("");
  const [form] = Form.useForm();
  const [formDetails, setFormDetails] = useState({});
  const [addressType, setAddressType] = useState({
    home: false,
    custom: false,
    branch: true,
  });
  const accountList = useSelector(accountListSelector);
  const selectedAccount = useSelector(selectedAccountSelector);
  const [address, setAddress] = useState("");
  const [message, setMessage] = useState("");
  const [pinMessage, setPinMessage] = useState("");
  const profileDetails = useSelector(profileDetailsSelector);
  const [leavesDetails, setLeavesDetails] = useState({ leaves: [] });
  const [successVisible, setSuccessVisible] = useState(false);
  const [verifyReqDetails, setVerifyReqDetails] = useState({});
  const [pincode, setPincode] = useState("");

  useEffect(() => {
    if (accountList.length > 0) {
      leavesList(accountList[0]);
    }
  }, [accountList]);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();
      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            onConfirm={(values) =>
              chequeBookConfirmation({ ...verifyReqDetails, ...values })
            }
            handleResendOtp={() => chequeBookVerification()}
            cancelTransaction={() => {
              navigate("/request");
            }}
          />
        );

      default:
        return renderForm();
    }
  }

  const handleChange = useCallback((type, value) => {
    try {
      setAddressType({ ...defaultType, [type]: true });
      if (type !== "custom") {
        setAddress("");
        setPincode("");
        setMessage("");
        setPinMessage("");
      }
    } catch (error) {}
  }, []);

  const leavesList = useCallback(async (values) => {
    try {
      const response = await ChequeService.leavesList({
        accountNo: values?.accountNo,
      });
      if (response.status === 200) {
        setLeavesDetails(response.data);
        form.setFieldsValue({
          noOfChequeLeaves: response.data["leaves"][0],
        });
      }
    } catch (error) {}
  }, []);

  const onVerify = useCallback((values) => {
    try {
      setStage(2);
      setFormDetails(values);
    } catch (error) {}
  }, []);

  const getSrcAccDetails = useCallback(() => {
    return accountList.find(
      (ele) => ele.accountNo === selectedAccount.accountNo
    );
  }, [accountList, selectedAccount]);

  const chequeBookVerification = useCallback(async () => {
    try {
      const srcAccDetails = getSrcAccDetails();
      if (address.length === 0 && addressType.custom === true) {
        setMessage("Please enter address");
        return;
      }
      if (pincode.length === 0 && addressType.custom === true) {
        setPinMessage("Please enter valid pincode");
        return;
      }
      const req = {
        accountName: srcAccDetails?.acctShortName,
        accountNo: srcAccDetails?.accountNo,
        address: addressType.branch
          ? leavesDetails?.customerAddress
          : addressType.home
          ? profileDetails?.homeAddress
          : `${address},${"Pincode"} : ${pincode}`,
        branchCode: srcAccDetails?.branchId,
        cifId: srcAccDetails?.customerId,
        companySignature: "",
        deliveryMode: "B",
        designation: "",
        name: leavesDetails?.customerName,
        noOfChequeLeaves: formDetails?.noOfChequeLeaves,
        remarks: "",
        secondName: "",
        thirdName: "",
        typeOfAddress: addressType.branch
          ? "REGISTERED"
          : addressType.home
          ? "HOME"
          : "CUSTOM",
      };
      setMessage("");
      setVerifyReqDetails(req);
      const response = await ChequeService.chequeBookVerification(req);
      if (response.status === 200) {
        if (response.data["data"]["otpEnable"]) {
          setStage(3);
        } else {
          chequeBookConfirmation({
            ...req,
            ...{ otp: CONFIG.DEFAULT_OTP },
          });
        }
      }
    } catch (error) {}
  }, [
    leavesDetails,
    addressType,
    address,
    pincode,
    profileDetails,
    formDetails,
  ]);

  const chequeBookConfirmation = useCallback(async (values) => {
    try {
      const response = await ChequeService.chequeBookConfirmation(values);
      if (response.status === 200) {
        setMessage(response.data["data"]);
        setSuccessVisible(true);
      }
    } catch (error) {
      setOtp("");
    }
  }, []);

  function renderForm() {
    return (
      <>
        <div className="row">
          <div className="d-flex align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
              <AccountDisplay type="image" />
            </div>
          </div>
        </div>
        <Form form={form} layout="vertical" onFinish={onVerify}>
          <div>
            <Form.Item
              label={t("pages.settings.no_of_leaves", {
                defaultValue: "Number Of Leaves",
              })}
              name="noOfChequeLeaves"
              rules={[
                {
                  required: true,
                  message: t("pages.settings.no_of_leaves_req", {
                    defaultValue: "Number Of Leaves is required",
                  }),
                },
              ]}
            >
              <Select
                placeholder={t("pages.settings.no_of_leaves", {
                  defaultValue: "Number Of Leaves",
                })}
              >
                {leavesDetails?.leaves.map((option, idx) => (
                  <Select.Option key={idx} value={option}>
                    {option}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="d-flex justify-content-end  mt-3">
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              className="primary-btn"
            >
              {t("buttons.submit_btn", {
                defaultValue: "Submit",
              })}
            </Button>
          </div>
        </Form>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        <p className="mb-3" style={{ fontSize: 14 }}>
          {t("pages.settings.delivery_txt", {
            defaultValue:
              "Where would you like your cheque book to be delivered ?",
          })}
        </p>

        <div className="row">
          <div className="d-flex align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
              <AccountDisplayView />
            </div>
          </div>
        </div>

        <p className="mb-3">
          {" "}
          {t("pages.settings.deliver_to", {
            defaultValue: "Deliver to",
          })}
        </p>
        <div
          className="d-flex mb-3"
          onClick={() => handleChange("branch", addressType.branch)}
        >
          <span style={{ marginRight: 10 }}>
            {!addressType.branch && (
              <IoRadioButtonOff style={{ fontSize: 20 }} />
            )}
            {addressType.branch && (
              <IoCheckmarkCircleSharp
                className="primary-color"
                style={{ fontSize: 20 }}
              />
            )}
          </span>
          <span>
            <span>
              {t("pages.card_settings.registered_address", {
                defaultValue: "Registered Address",
              })}
            </span>
            {addressType.branch && (
              <Card className="mt-1 application-card">
                {leavesDetails?.customerAddress}
              </Card>
            )}
          </span>
        </div>
        <div
          className="d-flex mb-3"
          onClick={() => handleChange("home", addressType.home)}
        >
          <span style={{ marginRight: 10 }}>
            {!addressType.home && <IoRadioButtonOff style={{ fontSize: 20 }} />}
            {addressType.home && (
              <IoCheckmarkCircleSharp
                className="primary-color"
                style={{ fontSize: 20 }}
              />
            )}
          </span>
          <span>
            <span>
              {t("pages.card_settings.home_branch", {
                defaultValue: "Home Branch",
              })}
            </span>
            {addressType.home && (
              <Card className="mt-1 application-card">
                {profileDetails?.homeAddress}
              </Card>
            )}
          </span>
        </div>
        <div
          className="d-flex mb-3"
          onClick={() => handleChange("custom", addressType.custom)}
        >
          <span style={{ marginRight: 10 }}>
            {!addressType.custom && (
              <IoRadioButtonOff style={{ fontSize: 20 }} />
            )}
            {addressType.custom && (
              <IoCheckmarkCircleSharp
                className="primary-color"
                style={{ fontSize: 20 }}
              />
            )}
          </span>
          <span>
            <span>
              {t("pages.card_settings.custom_address", {
                defaultValue: "Custom Address",
              })}
            </span>
            <div>
              {addressType.custom && (
                <Input.TextArea
                  className="mt-1 txt-area-style"
                  onInput={(e) => {
                    setAddress(e.target.value);
                    setMessage("");
                  }}
                  value={address}
                  rows={3}
                  showCount
                  maxLength={200}
                  maxlength={200}
                  onKeyPress={(e) => allowOnlyAlphaNumericsWithSpaceAndComma(e)}
                />
              )}
              <p style={{ color: "red" }}>{message}</p>
            </div>
            {addressType.custom && (
              <div>
                <label>
                  {t("pages.card_settings.pin_code", {
                    defaultValue: "Pin Code",
                  })}
                </label>
                <Input
                  onKeyPress={(e) => allowOnlyNumbers(e)}
                  onInput={(e) => {
                    setPincode(e.target.value);
                    setPinMessage("");
                  }}
                  maxLength={6}
                  placeholder={t("pages.settings.enter_pincode", {
                    defaultValue: "Enter Pin Code",
                  })}
                  value={pincode}
                />
                <p style={{ color: "red" }}>{pinMessage}</p>
              </div>
            )}
          </span>
        </div>
        <div className="d-flex justify-content-end  mt-3">
          <Button type="default" onClick={() => setStage(1)} size="large">
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>
          <Button
            style={{ marginLeft: 20 }}
            type="primary"
            className="primary-btn"
            onClick={() => chequeBookVerification()}
            size="large"
          >
            {t("pages.settings.order_now", {
              defaultValue: "Order Now",
            })}
          </Button>
        </div>
      </>
    );
  }

  return (
    <div>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/settings")}>
              {t("navigation.other", {
                defaultValue: "Other Services",
              })}
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/request")}>
              {t("pages.my_accounts.cardless_cash.request", {
                defaultValue: "Service Request",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              
               {t("navigation.cheque_book_request", {
                defaultValue: "Cheque Book Request",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.cheque_book_request", {
                defaultValue: "Cheque Book Request",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <div className="row d-flex justify-content-between">
        <div className="row d-flex justify-content-between">
          {stage === 1 ? (
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
              <Card
                className="application-card"
              >
                <AccountCard />
              </Card>
            </div>
          ) : (
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
              <Card
                className="application-card"
                
              >
                <AccountSelectedCard />
              </Card>
            </div>
          )}
          <div className="col-8">
            <Card className="payee-render-section application-card">
              {renderSwitch()}
            </Card>
          </div>
        </div>
      </div>

      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        // className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message?.message} </p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/request");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
